import RequestPrescreenerAdministrativeController from 'client-portal/controllers/-request/prescreener-administrative';

export default class WidgetPrescreenerAdministrative extends RequestPrescreenerAdministrativeController {}
